// @ts-nocheck
/**
 * One-step onboarding for Admin+ Transactions when opened with ?tour=true.
 * @param {object} vm - Vue component instance with $t
 */
export function buildTransactionsAdminPlusTourSteps(vm) {
  const t = (key) => vm.$t(key);
  return [
    {
      target: '[data-v-step="5"]',
      icon: require("@/assets/icons/admin+/academy_transactions.svg"),
      label: t("message.onboarding_transactions_label"),
      title: t("message.onboarding_transactions_title"),
      before() {
        const element = document.querySelector('[data-v-step="5"]');
        if (element) {
          element.click();
        }
      },
      autoClick: true,
      description: t("message.onboarding_transactions_description"),
      params: {
        placement: "left",
        highlight: true,
      },
    },
  ];
}
